import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reader",
  "use": "icon-reader-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-reader\"><path d=\"M512 928c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32v704c0 17.7-14.3 32-32 32z\" /><path d=\"M893.2 928H130.8C76.3 928 32 883.7 32 829.2V194.8C32 140.3 76.3 96 130.8 96h247.5c54.8 0 103.5 26.8 133.7 67.9C542.2 122.8 590.9 96 645.7 96h247.5c54.5 0 98.8 44.3 98.8 98.8v634.3c0 54.6-44.3 98.9-98.8 98.9zM130.8 160c-19.2 0-34.8 15.6-34.8 34.8v634.3c0 19.2 15.6 34.8 34.8 34.8h762.3c19.2 0 34.8-15.6 34.8-34.8V194.8c0-19.2-15.6-34.8-34.8-34.8H645.7C589.6 160 544 205.6 544 261.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-56.1-45.6-101.7-101.7-101.7H130.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/reader.svg
// module id = mLuo
// module chunks = 65